export const createReducer = (initialState = {}, handlers = {}) => {
  return (state = initialState, action = {}) => {
    if (
      Object.prototype.hasOwnProperty.call(handlers, action.type) &&
      typeof handlers[action.type] === 'function'
    ) {
      return { ...state, ...handlers[action.type](state, action) };
    }
    return state;
  };
};
